
<div *ngIf="card" class="btn-track chip d-inline-block px-2 py-1" >
    <div class="d-flex flex-row align-items-center" (click)="onShareClick()">
        <img class="picto-medium" src="../../../assets/images/231116/pictos/Share.svg" />
        <div *ngIf="cardService.getNumberOfShare(card) == undefined" class="typo-chip ms-2">{{ 'wap1_m_share_share' | translate }}</div>
        <div *ngIf="cardService.getNumberOfShare(card) as nbShare" class="typo-chip ms-1">{{ nbShare }}</div>
    </div>
</div>